import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Router} from "@angular/router";
import {Observable} from 'rxjs';
import { RestUrlsConfig } from "@signature-it/ngx-generic/config";
import { LanguageService } from "@signature-it/ngx-generic/services";

@Injectable({
    providedIn: 'root'
})

export class MapService {
    protected getEntityMapUrl = `${this.config.appURL}/public/map/`;

    constructor(
        protected http: HttpClient,
        protected config: RestUrlsConfig,
        protected router: Router,
        protected langSvc: LanguageService
    ) {}

    getEntityMap(type_var: string): Observable<any> {
        const currLang = this.langSvc.getCurrentLanguage();
        return this.http.get(`${this.getEntityMapUrl}/${type_var}?lang_code=${currLang.code}`);
    }
}
